//import MultyLineTextView from "@/pcomponents/common/crud/view/multy_line_text";
function MultyLineTextView(props:any){
   let myProps={
    text:"",
    style:{},
    ...props
  };
  if(myProps.text==undefined){
    myProps.text="";
  }
  myProps.text=String(myProps.text)+"";
  let text_style={
    ...myProps.style
  };
  
  return (
  <>
    {
      myProps.text && myProps.text.split('\n').map( (line:string,idx:number) => {
        return (<span key={idx} style={text_style} >{line}<br/></span>)
      })
    }
  </>
  );
};
export default MultyLineTextView;